import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export const updateUserRole = async (payload: {
  companyId: number
  userId: number
  role: string
}) => {
  const { data } = await companiesApi.put(
    apiRoutes.updateUserByCompany(payload.companyId, payload.userId),
    { role: payload.role },
  )

  return data
}
